export default __webpack_public_path__ + "static/media/FOTO3.128c5ff4.png";